import { ReactNode, useEffect } from 'react';
import styled from 'styled-components';
import { useMouseStore } from '../../hooks/stores/mouseStore';
import { useUIStore } from '../../hooks/stores/uiStore';
import { SidebarResizeHandle } from './SidebarResizeHandle';

export const Sidebar = ({ children }: { children: ReactNode }) => {
  const [UIData, setUIData] = useUIStore();
  const [mouseData] = useMouseStore();

  useEffect(() => {
    if (!mouseData.isDown) {
      if (UIData.sidebarWidth < 170) {
        setUIData({ isSidebarOpen: false, sidebarWidth: 300 });
      }
    }
  }, [mouseData.isDown]);

  return (
    <Container
      $isOpen={UIData.isSidebarOpen}
      style={{
        width: UIData.isSidebarOpen ? UIData.sidebarWidth : undefined,
        minWidth: '45px',
        transition: UIData.isSidebarResizing ? 'none' : undefined,
      }}
    >
      {children}
      {UIData.isSidebarOpen && <SidebarResizeHandle />}
    </Container>
  );
};

export const Container = styled.aside<{ $isOpen: boolean }>`
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  max-width: 50%;
  height: calc(100vh - 18px);

  display: flex;
  flex-direction: column;

  background-color: var(--neutral-2);
  border-right: 1px solid var(--neutral-3);

  transition: width var(--transition-1);

  ${({ $isOpen }) =>
    !$isOpen &&
    `
    width: 45px;
    overflow: hidden;
  `}
`;
